export default __webpack_public_path__ + "static/book-stack-f4514e544e7ac9bc86cd80006c1672e8.png";